import React from 'react'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-xcode'
import { makeStyles } from '@material-ui/core'
import { useEditor } from './EditorContext'

const useStyles = makeStyles(() => ({
  panel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  header: {
    flexShrink: 0,
    padding: '8px 12px',
    borderBottom: '1px solid var(--color-neutral-200)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 'var(--text-weight-bold)',
    color: 'var(--color-neutral-500)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: 'var(--color-neutral-050)'
  },
  errorTag: {
    fontWeight: 500,
    color: 'var(--color-danger-600)',
    textTransform: 'none'
  },
  editorWrap: {
    flex: 1,
    minHeight: 0,
    position: 'relative'
  }
}))

function JsonPanel () {
  const classes = useStyles()
  const { pipelineText, setPipelineText, pipelineParse } = useEditor()

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <span>Pipeline JSON {pipelineParse.error && <span className={classes.errorTag}>· invalid JSON</span>}</span>
      </div>
      <div className={classes.editorWrap}>
        <AceEditor
          mode='json'
          theme='xcode'
          name='ddp-versioned-json'
          width='100%'
          height='100%'
          value={pipelineText}
          onChange={setPipelineText}
          tabSize={2}
          editorProps={{ $blockScroll: true }}
          setOptions={{ useWorker: false, showPrintMargin: false }}
        />
      </div>
    </div>
  )
}

export default JsonPanel
